const EnvVars = [
  'VITE_GOOGLE_RECAPTCHA_V2_SITE_KEY',
  'VITE_GOOGLE_RECAPTCHA_V3_SITE_KEY',
  'VITE_ROLLBAR_ACCESS_TOKEN',
  'VITE_ROLLBAR_ENABLED',
  'VITE_ENV'
] as const;

type EnvVar = (typeof EnvVars)[number];

export const env = {
  get(envVar: EnvVar) {
    return import.meta.env[envVar] as any;
  },

  isTrue(envVar: EnvVar) {
    return String(this.get(envVar)).toLowerCase() === 'true';
  },

  isDev() {
    return import.meta.env.MODE === 'dev';
  },

  isProd() {
    return import.meta.env.MODE === 'prod';
  },

  isStage() {
    return import.meta.env.MODE === 'stage';
  },

  isTest() {
    return import.meta.env.MODE === 'test';
  }
};
